
const table = `<table class='table table-bordered table-striped floatedTable'>
    <thead>
    <tr>
    <th>Purpose code</th><th>Classification</th><th>Name</th><th>Description</th>	 		
    </tr>
    </thead>
    <tbody>
    <tr><td>HLRP</td> <td>Finance</td><td>Property Loan Repayment</td><td>Transaction is related to a payment of a property loan.</td></tr>
    <tr><td>HLST</td><td>Finance</td><td>Property Loan Settlement</td><td>Transaction is related to the settlement of a property loan.</td></tr>
    <tr><td>PLDS</td><td>Finance</td><td>Property Loan Disbursement</td><td>Payment of funds from a lender as part of the issuance of a property loan.</td></tr>
    <tr><td>PDEP</td><td>Finance</td><td>Property Deposit</td><td>Payment of the deposit required towards purchase of a property.</td></tr>
    <tr><td>PCOM</td><td>Finance</td><td>Property Completion Payment</td><td>Final payment to complete the purchase of a property.</td></tr>    <tr><td>PLRF</td><td>Finance</td><td>Property Loan Refinancing</td><td>Transfer or extension of a property financing arrangement to a new deal or loan provider, without change of ownership of property.</td></tr>
    </tbody>
</table>`;

const purposeCodesSheet = `
    <div class="col-3 offset-0">
    <div class="tile">
        <a class="import-guide-link" href='${process.env.PUBLIC_URL}/importGuides/purposeCodes/Payment_purpose_codes_325.xlsx' download>
            <div class="tile-icon"><i class="fa fa-book" title="Payment purpose codes"></i></div>
            <h3 class="title text-content">Payment purpose codes</h3>
        </a>
    </div>
    </div>`;

export const purposeCodes = `
<p>
Payment purpose codes are 4-character alphanumeric codes which should be used when making a CHAPS payment related to a property transaction or making payments between financial institutions.  The following six codes are the most likely to be used, however, we have also included a full list further below, for reference which is part of the ISO 20022 repository.
</p>
<hr style="border-top: 4px solid #006a4d;"></hr>
${table}
<hr style="border-top: 4px solid #006a4d;"></hr>
<p>The below document contains the full list of payment purpose codes available.  The most useful columns to review are labelled ‘Code Value’, ‘Code Name’, ‘Code Definition’ and ‘Additional information’, where you’ll find the code’s classification.</p>
${purposeCodesSheet}
`;



// WEBPACK FOOTER //
// ./src/components/content/appendices/5-purposeCode.ts